import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDigiKeyelectronicsComponent } from './simple-icons-digi-keyelectronics.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDigiKeyelectronicsComponent ],
    exports:      [ SimpleIconsDigiKeyelectronicsComponent ],
    bootstrap:    []
})
export class SimpleIconsDigiKeyelectronicsModule {}
